// @ts-nocheck
import type * as Types from '../../../types/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PayPledgeMutationVariables = Types.Exact<{
  input: Types.PayPledgeInput;
}>;


export type PayPledgeMutation = { __typename?: 'Mutation', payPledge: { __typename?: 'PayPledgeResult', id: string, clientSecret: string } };


export const PayPledgeDocument = /*#__PURE__*/ gql`
    mutation PayPledge($input: PayPledgeInput!) {
  payPledge(input: $input) {
    id
    clientSecret
  }
}
    `;

/**
 * __usePayPledgeMutation__
 *
 * To run a mutation, you first call `usePayPledgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePayPledgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [payPledgeMutation, { data, loading, error }] = usePayPledgeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePayPledgeMutation(baseOptions?: Apollo.MutationHookOptions<PayPledgeMutation, PayPledgeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PayPledgeMutation, PayPledgeMutationVariables>(PayPledgeDocument, options);
      }
export type PayPledgeMutationHookResult = ReturnType<typeof usePayPledgeMutation>;